var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55664 9H5.55664V13H3.55664V9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55664 3H9.55664V13H7.55664V3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5566 6H13.5566V13H11.5566V6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5566 1.5H3.55664C2.72821 1.5 2.05664 2.17157 2.05664 3V13C2.05664 13.8284 2.72821 14.5 3.55664 14.5H13.5566C14.3851 14.5 15.0566 13.8284 15.0566 13V3C15.0566 2.17157 14.3851 1.5 13.5566 1.5ZM3.55664 0C1.89979 0 0.556641 1.34315 0.556641 3V13C0.556641 14.6569 1.89979 16 3.55664 16H13.5566C15.2135 16 16.5566 14.6569 16.5566 13V3C16.5566 1.34315 15.2135 0 13.5566 0H3.55664Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartS);
export default __webpack_public_path__ + "static/media/chart-S.84c0e50a632a9cf076cdcd28d90e95e8.svg";
export { ForwardRef as ReactComponent };